/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pkl_Note_Create_PnkInputs */

const vi_pkl_note_create_pnk = /** @type {(inputs: Pkl_Note_Create_PnkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo phiếu nhập`)
};

/**

* @param {Pkl_Note_Create_PnkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pkl_note_create_pnk = /** @type {((inputs?: Pkl_Note_Create_PnkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pkl_Note_Create_PnkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pkl_note_create_pnk(inputs)
});